var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":"","my-5":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","offset-md2":""}},[_c('p',{staticClass:"d-block pa-5 display-4 text-xs-center"},[_vm._v("404 Not Found")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }